/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export const SNS_PAYMENT_TYPE = {
  SINGLE: "SINGLE",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
}

export default ($axios: any) => ({
  // 결제내역 조회
  async index(data?: any) {
    return camelize(await $axios.get(`/sns/payments`, snakelize({ params: data })))
  },
})
